module.exports = __webpack_public_path__ + "img/private-key.87cdb72a.svg";